export enum PlanningAggregationOptionEnum {
    MIN= 'MIN',
    MAX = 'MAX',
    AVERAGE = 'AVERAGE',
    NEWEST = 'NEWEST'
}
